/**
 * type
 *
 * The subject is an instance of a class.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#type
 */
var type = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type';
/**
 * subject
 *
 * The subject of the subject RDF statement.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#subject
 */
var subject = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#subject';
/**
 * predicate
 *
 * The predicate of the subject RDF statement.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#predicate
 */
var predicate = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#predicate';
/**
 * object
 *
 * The object of the subject RDF statement.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#object
 */
var object = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#object';
/**
 * value
 *
 * Idiomatic property used for structured values.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#value
 */
var value = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#value';
/**
 * first
 *
 * The first item in the subject RDF list.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#first
 */
var first = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#first';
/**
 * rest
 *
 * The rest of the subject RDF list after the first item.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#rest
 */
var rest = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#rest';
/**
 * language
 *
 * The language component of a CompoundLiteral.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#language
 */
var language = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#language';
/**
 * direction
 *
 * The base direction component of a CompoundLiteral.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#direction
 */
var direction = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#direction';
/**
 * Property
 *
 * The class of RDF properties.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#Property
 */
var Property = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property';
/**
 * Statement
 *
 * The class of RDF statements.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#Statement
 */
var Statement = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Statement';
/**
 * Bag
 *
 * The class of unordered containers.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#Bag
 */
var Bag = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Bag';
/**
 * Seq
 *
 * The class of ordered containers.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#Seq
 */
var Seq = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Seq';
/**
 * Alt
 *
 * The class of containers of alternatives.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#Alt
 */
var Alt = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Alt';
/**
 * List
 *
 * The class of RDF Lists.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#List
 */
var List = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#List';
/**
 * CompoundLiteral
 *
 * A class representing a compound literal.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#CompoundLiteral
 */
var CompoundLiteral = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#CompoundLiteral';
/**
 * HTML
 *
 * The datatype of RDF literals storing fragments of HTML content
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML
 */
var HTML = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML';
/**
 * langString
 *
 * The datatype of language-tagged string values
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#langString
 */
var langString = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString';
/**
 * PlainLiteral
 *
 * The class of plain (i.e. untyped) literal values, as used in RIF and OWL 2
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral
 */
var PlainLiteral = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral';
/**
 * XMLLiteral
 *
 * The datatype of XML literal values.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral
 */
var XMLLiteral = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral';
/**
 * JSON
 *
 * The datatype of RDF literals storing JSON content.
 *
 * http://www.w3.org/1999/02/22-rdf-syntax-ns#JSON
 */
var JSON = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#JSON';

var rdfImport = /*#__PURE__*/Object.freeze({
	type: type,
	subject: subject,
	predicate: predicate,
	object: object,
	value: value,
	first: first,
	rest: rest,
	language: language,
	direction: direction,
	Property: Property,
	Statement: Statement,
	Bag: Bag,
	Seq: Seq,
	Alt: Alt,
	List: List,
	CompoundLiteral: CompoundLiteral,
	HTML: HTML,
	langString: langString,
	PlainLiteral: PlainLiteral,
	XMLLiteral: XMLLiteral,
	JSON: JSON
});

export { Alt as A, Bag as B, CompoundLiteral as C, HTML as H, JSON as J, List as L, Property as P, Statement as S, XMLLiteral as X, Seq as a, langString as b, PlainLiteral as c, direction as d, rdfImport as e, first as f, language as l, object as o, predicate as p, rest as r, subject as s, type as t, value as v };
